<cc-settings-block
  [ngStyle]="{'margin-top': messages.length === 1 ? '0' : '1.5rem'}"
>
  <cc-settings-header
    header="{{ title | translate }}">
    <mat-checkbox
      *ngIf="messages.length > 1"
      [checked]="allOpened"
      (click)="openAll()"
    ><span translate>PHONE.MESSAGES.HEADER_SHOW</span>
    </mat-checkbox>
  </cc-settings-header>
  <cc-settings-body>
    <div *ngFor="let message of messages; let i = index" class="cc-messages-row">
      <div *ngIf="message.isSeparator; then separatorComponent else messageComponent"></div>
      <ng-template #separatorComponent>
        <div class="cc-messages-separator" [translate]="message.header"></div>
      </ng-template>
      <ng-template #messageComponent>
        <cc-messages-row
          [description]="message.description"
          [header]="message.header"
          [type]="message.type"
          [canBeEnabled]="message.canBeEnabled"
          [permission]="message.permission"
          [opened]="opened[i]"
          [msisdnId]="msisdnId"
          [numberConfig]="numberConfig"
          (changeOpened)="changeOpen($event, i)"
          (inboundSettingsChanged)="inboundSettingsChanged.emit()"
          (settingsChanged)="settingsChanged.emit()"
        ></cc-messages-row>
      </ng-template>
    </div>
  </cc-settings-body>
  <cc-settings-footer
    body="{{ 'PHONE.MESSAGES.FOOTER_BODY' | translate }}"></cc-settings-footer>
</cc-settings-block>
